import { action } from "typesafe-actions";
import { UserActionTypes } from "./types";
import { IUser } from "../../model";

export const updateUser = (newUser: IUser) =>
  action(UserActionTypes.UPDATE_USER, newUser);
